import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useScrollToAnchor } from 'src/hooks/use-scroll-to-anchor';

import { SiteFooter } from './footer/site-footer';
import { SiteHeader } from './header/site-header';

export function MainLayout() {
  const { t } = useTranslation('common');

  useScrollToAnchor();

  return (
    <>
      <a href="#main-content" className="skip-link">
        {t('labels.skipToContent')}
      </a>
      <SiteHeader />
      <main id="main-content">
        <Outlet />
      </main>
      <SiteFooter />
    </>
  );
}
